import { render } from "./tourProfile.vue?vue&type=template&id=a4218fc6"
import script from "./tourProfile.vue?vue&type=script&lang=js"
export * from "./tourProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__